import { createContext } from 'react';
import { Context } from './BCResult.types';

export const context = createContext<Context>({
  tickets: [],
  images: [],
  resultTask: null,
  setResultTask: () => null,
  editingVehicleIndex: null,
  setEditingVehicleIndex: () => null,
  routes: [],
  vehicles: [],
});
